
const websiteBaseUrl = (process.env.REACT_APP_BASE_URL || '/').replace(/\/$/, '');

class MarkupTools {
    static ApplyTextFormatting(text) {
        if (!text || !text.replace) {
            return text;
        }
        text = text.replace(/__([\w\s]+)__/gi, '<u>$1</u>');
        text = text.replace(/[*]{2}([\w\s]+)[*]{2}/gi, '<b>$1</b>');
        return text;
    }

    static balanceTags(html) {
        const count = (re) => (html.match(re) || []).length;

        let result = html;
        let appendClosingTags = '';
        for (let tagName of ['b', 'u']) {
            const openRegex = new RegExp(`<${tagName}[^>]*>`, "gi");
            const openTagCount  = count(openRegex);
            const closeRegex = new RegExp(`</${tagName}[^>]*>`, "gi");
            const closeTagCount = count(closeRegex);
            if (openTagCount > closeTagCount) appendClosingTags += `</${tagName}>`.repeat(openTagCount - closeTagCount);
            if (result.substring(result.length - 3) === `</${tagName}`) {
                result = result.substring(0, result.length - 3);
            } else if (result.substring(result.length - 2) === `</`) {
                result = result.substring(0, result.length - 2);
            } else if (result.substring(result.length - 1) === `<`) {
                result = result.substring(0, result.length - 1);
            }
        }
        result = result + appendClosingTags;
        return result;
    }

    static ApplyFormattingAndLinks(text, max_len = 160, expandable = true) {
        if (!text || !text.replace) {
            return text;
        }

        text = MarkupTools.ApplyTextFormatting(text);
        // Shorten too long texts
        if (text.length > max_len) {
            const textSnippet = this.balanceTags(text.substring(0, max_len)); // Closing tags could be cut off, balance them in the snippet
            if (expandable) {
                text = '<span>' + textSnippet + '</span><span>... <a href="" onclick="event.preventDefault(); let p = this.parentElement; p.nextElementSibling.style.display = \'inline\'; p.previousElementSibling.remove(); p.remove(); return false;">(lue kokonaan)</a></span><span style="display: none;">' + text + '</span>';
            } else {
                text = textSnippet + '...';
            }
        }

        // Linkify categories
        const categoryRegex = /(#\b[a-z0-9\-]{2,64}\b)/ig;
        text = text.replace(categoryRegex, function(category) {
            if (!category) {
                return category;
            }
            return '<a href="' + websiteBaseUrl + '/kategoria/' + ('' + category).replace('#', '') + '">' + category + '</a>';
        });
        // @todo: LINKIFY OTHER THINGS, E.G. @MENTIONS AND OTHER THINGS?
        return text;
        /*const urlRegex = /(\bhttps:\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/ig;
        return text.replace(urlRegex, function(url) {
            return '<a href="' + url + '" target="_blank" rel="noopener noreferrer">' + url.replace('https://', '') + '</a>';
        });*/
    }
}

export default MarkupTools;
